// src/views/PastorsFeed.js
import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import OnePastor from "../ones/OnePastor";

export default function PastorsFeed(props) {

  const appContext = useContext(AppContext);

  const [ready, setReady] = useState(false);
  const [pastors, setPastors] = useState([]);

  async function init() {
    setReady(false);

    // sample data (for now)
    setPastors([
      {
        fullname: "Pastor Daniel Mwita",
        church: "Grace Church",
        location: "Dar es Salaam",
      },
      {
        fullname: "Rev. Sarah Nyerere",
        church: "Faith & Hope Ministries",
        location: "Arusha",
      },
      {
        fullname: "Pastor Joseph Mshana",
        church: "New Life Church",
        location: "Mwanza",
      },
    ]);

    setReady(true);
  }

  useEffect(() => {
    init();
  }, [])

  if (ready) {
    return (
      
      <div className="container">
        <div className="row">

          <div className="col-md-12">
            <h6 className="main-section-title" style={{ marginBottom: "16px" }}>
              Pastors
            </h6>
          </div>

          <div className="col-md-12">
            {
              pastors.map((p, i) => (
                <OnePastor
                  key={i}
                  pastor={p}
                />
              ))
            }
          </div>

        </div>
      </div>
    
    )
  } else {
    return (
      <div
        className="mSupportLoading"
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        {getInlineLoader()}
      </div>
    );
  }

}
